<div class="settings-tab">

  <!-- Context banner: helps users understand the purpose of each sub-section -->
  <div class="settings-context-banner">
    <mat-icon class="context-icon">tune</mat-icon>
    <div class="context-text">
      <strong>Class Settings</strong>
      <span>Manage tenant credentials, resource subscriptions, schedule, trainers, and enrolled participants for this class. Select a section below to configure it.</span>
    </div>
  </div>

  <mat-tab-group
    [(selectedIndex)]="selectedSectionIndex"
    animationDuration="150ms"
    class="settings-tab-group"
    (selectedIndexChange)="onSectionActivated($event)">

    <!-- Tenant Info -->
    <mat-tab label="Tenant">
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">domain</mat-icon> Tenant
      </ng-template>
      <div class="section-body">
        <app-tenant-settings [classEntity]="classEntity" [classId]="classId"
          (tenantConfigured)="tenantConfigured.emit()"></app-tenant-settings>
      </div>
    </mat-tab>

    <!-- VM Subscriptions (conditional) -->
    <mat-tab *ngIf="hasVmResource">
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">dns</mat-icon> VM Subscriptions
      </ng-template>
      <div class="section-body">
        <app-vm-subscription-settings
          [classEntity]="classEntity"
          [classId]="classId"
          (subscriptionsChanged)="subscriptionsChanged.emit()"
          (goToTenant)="navigateToTenant()"
          (vmCapacityChanged)="onVmCapacityChanged($event)"
          (vmGrossCapacityChanged)="onVmGrossCapacityChanged($event)"
          (vmQuotaStaleChanged)="onVmQuotaStaleChanged($event)"></app-vm-subscription-settings>
      </div>
    </mat-tab>

    <!-- VM Template (conditional — only when class has a VM resource) -->
    <mat-tab *ngIf="hasVmResource">
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">computer</mat-icon> VM Template
      </ng-template>
      <div class="section-body">
        <app-vm-template-settings
          [classId]="classId"
          [classEntity]="classEntity"
          [hasCloudSettings]="hasCloudSettings"
          (snapshotDone)="snapshotDone.emit()"
          (goToVmSubscriptions)="navigateToVmSubscriptions()">
        </app-vm-template-settings>
      </div>
    </mat-tab>

    <!-- Account Subscriptions (conditional) -->
    <mat-tab *ngIf="hasAccResource">
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">manage_accounts</mat-icon> Account Subscriptions
      </ng-template>
      <div class="section-body">
        <app-account-subscription-settings
          [classId]="classId"
          [classEntity]="classEntity"
          [participantCount]="participantCount"
          (subscriptionsChanged)="accSubscriptionsChanged.emit()"
          (goToTenant)="navigateToTenant()">
        </app-account-subscription-settings>
      </div>
    </mat-tab>

    <!-- Account Template (conditional — only when class has an ACC resource) -->
    <mat-tab *ngIf="hasAccResource">
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">account_box</mat-icon> Account Template
      </ng-template>
      <div class="section-body">
        <app-acc-template-settings
          [classId]="classId"
          [classEntity]="classEntity"
          [hasCloudSettings]="hasCloudSettings"
          [hasAccSubscriptions]="hasAccSubscriptions"
          (testingDone)="snapshotDone.emit()"
          (goToAccSubscriptions)="navigateToAccSubscriptions()">
        </app-acc-template-settings>
      </div>
    </mat-tab>

    <!-- Schedule -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">date_range</mat-icon> Schedule
      </ng-template>
      <div class="section-body">
        <app-schedule-settings [classEntity]="classEntity" [classId]="classId"></app-schedule-settings>
      </div>
    </mat-tab>

    <!-- Faculty — temporarily hidden; user assignment UX is not yet ready.
         TODO: re-enable once faculty search/attach flow is implemented (sprint task: TBD).
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">school</mat-icon> Faculty
      </ng-template>
      <div class="section-body">
        <app-faculty-settings [classEntity]="classEntity" [classId]="classId"></app-faculty-settings>
      </div>
    </mat-tab>
    -->

    <!-- Participants -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">group</mat-icon> Participants
      </ng-template>
      <div class="section-body">
        <app-participants-settings
          [classEntity]="classEntity"
          [classId]="classId"
          [maxParticipants]="maxEffectiveParticipants"
          [isCapacityLoading]="isCapacityLoading"
          [vmWise]="vmWiseCapacity"
          [accWise]="accWiseCapacity"
          [remainingVmCapacity]="remainingVmCapacity"
          [isQuotaStale]="anyVmQuotaStale"
          [isVmTemplateReady]="isVmTemplateReady"></app-participants-settings>
      </div>
    </mat-tab>

    <!-- Forward to Quota Settings -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="s-icon">forward</mat-icon> Forward
      </ng-template>
      <div class="section-body">
        <app-forward-settings
          [classEntity]="classEntity"
          [classId]="classId"
          [hasVmResource]="hasVmResource"
          [hasAccResource]="hasAccResource"
          [isVmTested]="isVmTested"
          [isAccTested]="isAccTested"
          [isClassConfirmed]="isClassConfirmed"
          (goToVmTemplate)="navigateToVmTemplate()"
          (goToAccTemplate)="navigateToAccTemplate()">
        </app-forward-settings>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
